<script setup lang="ts">
  import { onMounted, ref, watch } from 'vue';
  import { useI18n } from 'vue-i18n';
  import { useRoute } from 'vue-router';
  import PageContent from '@/components/customerPage/pageContent/PageContent.vue';
  import {
    ROUTE_NAME_BOOKING_VIEW,
    ROUTE_NAME_BOOKING_FORM_DATED,
    ROUTE_NAME_BOOKING_FORM_TEMPLATE,
  } from '@/config/routeNames';
  import type { ScheduleType } from '@/types';
  import AdmissionStatus from '@/components/customerPage/AdmissionStatus/AdmissionStatus.vue';
  import { mergeMessages } from '@/i18n';
  import BookingServiceRequestType from '@/components/tripBookingPage/BookingServiceRequestType.vue';

  const scheduleType = ref<ScheduleType>();
  const { t } = useI18n();
  const route = useRoute();

  await mergeMessages('tripBookingFormsMessages');

  function handleFormSelection(formType: ScheduleType): void {
    scheduleType.value = formType;
  }

  onMounted(() => {
    scheduleType.value =
      route.name === ROUTE_NAME_BOOKING_FORM_DATED
        ? 'dated'
        : route.name === ROUTE_NAME_BOOKING_FORM_TEMPLATE
          ? 'template'
          : undefined;
  });

  watch(route, (newRoute) => {
    if (newRoute.name === ROUTE_NAME_BOOKING_VIEW) {
      scheduleType.value = undefined;
    }
  });
</script>

<template>
  <PageContent
    class="gap-0 md:gap-0 pb-6"
  >
    <template
      v-if="!scheduleType"
      #header
    >
      <AdmissionStatus class="md:container" />
      <h1>{{ t('pages.tripBooking.title') }}</h1>
    </template>
    <BookingServiceRequestType
      v-if="!scheduleType"
      class="mt-6 md:container md:mt-10"
      @select="handleFormSelection"
    />
    <RouterView v-else />
  </PageContent>
</template>
